export const fontWeight = {
  REGULAR: 400,
  SEMIBOLD: 600,
  BOLD: 700,
} as const
